import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

function App() {
  return (
    <SwaggerUI url="https://development.smartdraft.com.au/swagger.json" />
  );
}

export default App;
